import styled from "styled-components";

export const BlogAuthorWrap = styled.div`

`
